import { QText, QTextProps } from '@qualio/ui-components';

export const QActivityText = ({
  text,
  weight = 'regular',
  ...textProps
}: Omit<QTextProps, 'children'> & { text: string }) => {
  return (
    <QText color="gray.700" fontSize="sm" weight={weight} {...textProps}>
      {text}
    </QText>
  );
};
